import { SummaryTimeView, SummaryTimeViews } from '../types'
import moment from '@e3dc-react/shell/Libs/moment'

/**
 * Calculates "from" timestamp. Is used to determine a time-span (from-to) for which to fetch data.
 *
 * @param view
 * @returns
 */
export const calculateFromBasedOnView = (view: SummaryTimeView): moment.Moment => {
  moment.locale('de')
  if (view === SummaryTimeViews.Year) return moment().startOf('year')
  if (view === SummaryTimeViews.Month) return moment().startOf('month')
  if (view === SummaryTimeViews.Week) return moment().startOf('week')
  return moment().startOf('day')
}

/**
 * Calculates the start or "from" timestamp of the previous period.
 * So if view is "week" than it return the start/from of the previous and not the current week.
 *
 * @param view
 * @returns
 */
export const calculatePreviousFromBasedOnView = (view: SummaryTimeView): moment.Moment => {
  return moment().add(-1, view).startOf(view)
}

/**
 *
 * @param view
 * @returns
 */
export const calculatePreviousToBasedOnView = (view: SummaryTimeView, from: moment.Moment): moment.Moment => {
  const previousFrom = moment(from.valueOf())
  return previousFrom.endOf(view)
}
